import { render, staticRenderFns } from "./HorseSearch.vue?vue&type=template&id=77164df4&"
import script from "./HorseSearch.vue?vue&type=script&lang=js&"
export * from "./HorseSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports